import en from './en';
import pt from './pt';

const translations = {
  en,
  pt,
};

export const getTranslation = (language) => {
  return translations[language] || translations.en;
};

export default translations;
